<template>
  <div v-if="settingsUp">
<!--    {{allState | json }}-->
    <div id="registration-state">
      <h1 v-if="currentSubsModel == 'onhb'">Inscrição na 42ª OMU</h1>
      <h1 v-else>Inscrição na Pré-ONHB2020</h1>
      <h2>{{currentSubsStepPublicFacingName}}</h2>
    </div>

    <div class="important-warning" v-if="currentSubsModel === 'preonhb' && alreadyStarted && subsStillGoing">
        <strong>ATENÇÃO:</strong> A Pré-ONHB 2020 já começou, no dia 27 de abril, segunda-feira! Porém até às {{currentPeriodEnd | moment('H[h]mm [do dia] D [de] MMMM')}} você ainda pode se inscrever, ou alterar a inscrição caso não tenha acessado a prova ainda!
    </div>

    <div class="important-warning" v-if="currentSubsModel === 'preonhb' && !subsStillGoing">
      <strong>ATENÇÃO:</strong> As inscrições foram encerradas às {{currentPeriodEnd | moment('H[h]mm [do dia] D [de] MMMM')}}.
    </div>

    <div class="important-warning" v-if="currentSubsModel === 'onhb' && !subsStillGoing">
      <strong>ATENÇÃO:</strong> As inscrições foram encerradas às {{currentPeriodEnd | moment('H[h]mm [do dia] D [de] MMMM')}}.
      <p v-if="teamSubsStillGoing">Porém é possível compor a sua equipe até às 23:59 do dia 02/4.</p>
    </div>

    <div id="loading-spinner" v-if="amILoading">
      <div class="sk-chase">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
    </div>

    <transition @before-leave="beforeLeave" name="fade-content" v-if="currentSubsStep == 'new'">
      <step-new />
    </transition>

    <transition
      @before-leave="beforeLeave"
      name="fade-content"
      v-if="currentSubsStep == 'institution'"
    >
      <step-institution />
    </transition>

    <transition
      @before-leave="beforeLeave"
      name="fade-content"
      v-if="currentSubsStep == 'teachers'"
    >
      <step-teachers />
    </transition>

    <transition
      @before-leave="beforeLeave"
      name="fade-content"
      v-if="currentSubsStep == 'terms_and_conditions'"
    >
      <step-terms-and-conditions />
    </transition>

    <transition @before-leave="beforeLeave" name="fade-content" v-if="currentSubsStep == 'user'">
      <step-user-id />
    </transition>

    <transition @before-leave="beforeLeave" name="fade-content" v-if="currentSubsStep == 'report'">
      <step-registration-report />
    </transition>

    <transition v-if="currentSubsStep == 'team-composition'" >
      <step-team-composition :highlight-process="currentParams().process"/>
    </transition>

    <div class="modal" v-if="modalShown">
    </div>

    <!--Translated to english: 'that which pops in', or simpĺy 'pop in'-->
    <div class="que-aparece-dentro" v-if="modalShown && billetWarnShown">
        <div class="window" v-if="currentSubsModel=='onhb'">
            <h3>Boleto gerado, com vencimento para {{billetWarnProc.NewSuiPayment.due_date}}</h3>
            <div>
                <!--{{billetWarnProc}}-->
                <p>O pagamento já está gerado. O seu processo de inscrição tem o código "{{billetWarnProc.NewSuiApplication.code}}", o boleto gerado possui o mesmo código na descrição. </p>
                <p>Agora, nesta página você pode montar a equipe, convidando os integrantes. </p>
                <p><strong>A inscrição estará completa para cada equipe quando a equipe tiver todos os membros cadastrados e validados E tiver o boleto pago e registrado.</strong> </p>
                <p><em>Nesta tela você pode acompanhar a montagem de todas as suas equipes e monitorar todas as pendências faltantes para a sua inscrição. Além de consultar os boletos e gerar boletos de pagamento atualizados.</em></p>
                <p><em>Caso alguma equipe tenha cupom de desconto disponível, a informação ficará visível no painel de cada equipe, que deverá declarar o uso do cupom e então atualizar a cobrança para ter o desconto aplicado.</em></p>
            </div>
            <div class="pop-buttons">
                <button :data-url="`${billetWarnProc.NewSuiPayment.link}`" class="btn" onclick="window.open(this.dataset.url, '_blank', 'menubar=0,toolbar=0,status=0,scrollbars=1')">Download do boleto</button>
                <button class="btn" @click="closeBilletWarn">Montar a(s) equipe(s) desta inscrição</button>
            </div>

        </div>
        <div class="window" v-else>
            <h3>Estamos quase lá ...</h3>
            <div>
                <p>Você iniciou sua inscrição, agora só falta preencher alguns dados sobre sua equipe para terminar sua inscrição! </p>
                <p>Se não tiver todos os dados na mão, não tem problema, quando quiser pode voltar aqui para fazer o login. </p>
            </div>
            <div class="pop-buttons">
                <button class="btn" @click="closeBilletWarn">Terminar de preencher os dados</button>
            </div>

        </div>
    </div>
  </div>
  <div v-else>
      <h2>Erro de conexão, tente novamente mais tarde.</h2>
  </div>

</template>

<script>
import { mapGetters } from "vuex";
import store from "../store";
import StepNew from "@/components/OnhbSubscripion/StepNew";
import StepInstitution from "@/components/OnhbSubscripion/StepInstitution";
import StepTeachers from "@/components/OnhbSubscripion/StepTeachers";
import StepTermsAndConditions from "@/components/OnhbSubscripion/StepTermsAndConditions";
import StepUserId from "@/components/OnhbSubscripion/StepUserId";
import StepRegistrationReport from "@/components/OnhbSubscripion/StepRegistrationReport";
import StepTeamComposition from "@/components/OnhbSubscripion/StepTeamComposition";
import Vue from "vue";
export default {
  name: "NothingButFlowers",
  beforeRouteEnter: function(to, from, next) {
    let promises = [
        Vue.axios.get("sui_login.json")
            .then(function (response) {
                if (response.data.SuiUser) {
                    store.commit('LOGIN_USER', {NewSuiUser: response.data.SuiUser});
                }
            }),

        Vue.axios.get(`new_sui_application.json?action=subscription_settings&subscription=${to.params.subsSlug}`, )
            .then(function (response) {
                store.commit('UPDATE_SUBSCRIPTION_SETTINGS', response.data);
            })
    ];

    Promise.all(promises)
      .finally(function () {
        if (to.params.step === 'team-composition') {
          if (!store.state.User.loggedIn) {
            location.href = process.env.VUE_APP_LOGIN_URL;
            return;
          }
          store.commit("GOTO_STEP_TEAM_COMPOSITION");
        }
        next();
      });
  },
  beforeRouteUpdate: function(to, from, next) {
    if (to.params.step == "new") {
      store.commit("RESTART_PROCESS");
    }

    if (to.params.step == "institution") {
      store.commit("BACK_TO_INSTITUTION");
    }

    if (to.params.step == "teachers") {
      store.commit("BACK_TO_TEACHERS");
    }

    if (to.params.step == "terms_and_conditions") {
      store.commit("BACK_TO_TERMS_AND_CONDITIONS");
    }

    next();
  },
  components: {
    StepNew,
    StepInstitution,
    StepTeachers,
    StepTermsAndConditions,
    StepUserId,
    StepRegistrationReport,
    StepTeamComposition
  },
  methods: {
    beforeLeave(el) {
      // https://forum.vuejs.org/t/transition-group-leave-transition-w-position-absolute-jumping-to-top-left-flip/12258/7
      const { marginLeft, marginTop, width, height } = window.getComputedStyle(
        el
      );
      el.style.left = `${el.offsetLeft - parseFloat(marginLeft, 10)}px`;
      el.style.top = `${el.offsetTop - parseFloat(marginTop, 10)}px`;
      el.style.width = width;
      el.style.height = height;
    },
    closeBilletWarn() {
        let highlightProcess = store.state.Interface.applicationId;
        store.commit("CLOSE_BILLET_WARN");
        this.$nextTick(function() {
            document.getElementById(`process-n-${highlightProcess}`).scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    },
    currentParams: function () {
        return this.$route.params;
    }
  },
  computed: {
    ...mapGetters([
      "currentSubsStep",
      "currentSubsStepPublicFacingName",
      "amILoading",
      "currentModality",
      "modalShown",
      "billetWarnShown",
      "currentSubsModel",
      "subsStillGoing",
      "teamSubsStillGoing",
      "alreadyStarted",
      "settingsUp",
      "currentPeriodEnd"
    ]),
    allState : function () {
      return store.state;
    },
    billetWarnProc: function () {
        return store.state.Applications[store.state.Interface.applicationId];
    }
  },
  watch: {
    modalShown (newValue) {
      document.body.style.overflow = newValue ? 'hidden' : '';
      Vue.nextTick(function () {
        let popupWindows = document.getElementsByClassName('window');
        for (let popWin of popupWindows) {
            popWin.scrollTop = 0;
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/static/css/_mixins.scss";
@import "@/assets/static/css/_definitions.scss";

.important-warning {
    padding: 10px;
    text-align: center;
    background: yellow;
}

.modal {
    height: 100%;
    width: 100%;
    position: fixed;
    background: RGBA(0, 0, 0, 0.1);
    left: 0;
    top: 0;
    z-index: 100;
}

.que-aparece-dentro {
    height: 100%;
    width: 100%;
    margin: auto;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 101;

    .window {
        &:after {
            content: " ";
            display: block;
            height: 40px;
        }

        z-index: 101;
        width: 700px;
        max-width: calc(100% - 40px);
        background-color: white;
        padding: 40px;
        margin: 40px auto 0;
        max-height: calc(100% - 80px);
        @include box_shadow(4, 3);
        overflow-y: auto;

        ul,ol {
            padding: pad(0);
            @include fs(0);
            list-style-position: outside;
            list-style-image: none;
            font-style: italic;
        }
        ol {
            list-style-type: decimal;
        }

        ul {
            list-style-type: square;
        }

        @include respond-below(sm) {
            padding: 15px;
            margin: 5px auto;
            max-height: calc(100% - 30px);
        }

        .pop-buttons {
            padding-top: 20px;
            display: flex;
            > button {
                flex-grow: 1;
                margin-right: 20px;
                background-color: accent();
                color: white;

                &:last-child {
                    margin-right: 0;
                }
            }
            > button.light {
                background-color: grays(8);
                color: black;
            }
        }
    }
}




#registration-state {
  text-align: center;
  h1 {
    @include fs(-1, 1);
    font-weight: 400;
    @include faux-caps;
    color: $onhb-color;
  }
  h2 {
    display: none;
    @include fs(1);
    font-style: italic;
  }
}

$trans-in: 0.7s;
$trans-out: 0.5s;

.fade-content-enter-active {
  transition: opacity $trans-in ease-in-out, transform $trans-in ease-in-out;
}
.fade-content-leave-active {
  position: absolute;
  transition: opacity $trans-out ease-in-out, transform $trans-out ease-in-out;
}

.fade-content-enter {
  opacity: 0;
  transform: translateY(5%) scale(1.1);
}
.fade-content-leave-to {
  opacity: 0;
  transform: translateY(-5%) scale(0.91);
}

.fade-content-enter-to,
.fade-content-leave {
  opacity: 1;
  transform: translateY(0) scale(1);
}

#loading-spinner {
  position: fixed;
  right: pad(2);
  bottom: pad(2);
}
</style>
